module.exports = __webpack_public_path__ + "img/grid-dots.41544c67.svg";